module.exports = __webpack_public_path__ + "img/1e18bde8bcffc35e9cfb870108a6fb6c.56c38bc5.png";